<template>
  <div>阅读页面</div>
</template>

<script>
  export default {
    name: 'read',
  }
</script>

<style scoped>

</style>